import * as React from "react";
import styled from "styled-components";
import { Card, CardBody, CardDescription, CardImage, CardTitle, CardSubTitle } from "../../../components/Card";
import { Media } from "../../../components/Media";
import { RichTextSmall } from "../../../components/RichText/specialties/RichTextSmall";
import { AspectRatio } from "../../../components/AspectRatio";
import { ContentEngagement } from "../../../components/ContentEngagement";
const aspectRatios = {
    arWide: 16 / 9,
    arLandscape: 4 / 3,
    arSquare: 1 / 1,
    arPortrait: 3 / 4,
};
const StylablePromoCard = ({ mediaPromoItem, layout, ...props }) => {
    const { media, title, subtitle, description, links } = mediaPromoItem;
    const action = links?.[0]?.action;
    const imageAspectRatio = (layout && aspectRatios[layout]) || 16 / 9;
    const CardComponent = (React.createElement(Card, { ...props, className: action ? `${props.className} action` : props.className },
        React.createElement(CardImage, { className: "action" },
            React.createElement(AspectRatio, { ratio: imageAspectRatio }, media && React.createElement(Media, { media: media }))),
        React.createElement(CardBody, null,
            title && React.createElement(CardTitle, null, title),
            subtitle && React.createElement(CardSubTitle, null, subtitle),
            !!description && (React.createElement(CardDescription, { "data-testid": "card-description" },
                React.createElement(RichTextSmall, { ...description }))))));
    return (React.createElement(ContentEngagement, { action: action, contentAnalytics: {
            id: title || "article-promo-card",
            title,
            uiType: "article-promo-card",
        } }, CardComponent));
};
StylablePromoCard.defaultProps = {
    "data-testid": "article-promo-card",
};
export const ArticlePromoCard = styled(StylablePromoCard) ``;
//# sourceMappingURL=ArticlePromoCard.js.map